module.exports = __webpack_public_path__ + "img/pdf.f59152c9.png";